module.exports = __webpack_public_path__ + "static/media/sort-able-svg.c3e129d1.svg";